import React from 'react'

function DataTableHead() {
    return (
        <thead className='DataTableHead'>
        <tr>
            <th rowSpan={2}>SKU</th>
            <th rowSpan={2} className='text-center'>Số lượng</th>
            <th colSpan={11} className='text-center'>Các trạng thái</th>
        </tr>
        <tr>
            <th className='text-center'>Pending</th>
            <th className='text-center'>Đã thiết kế</th>
            <th className='text-center'>Đã thêu</th>
            <th className='text-center'>Đang in</th>
            <th className='text-center'>Đã in</th>
            <th className='text-center'>Đang ép</th>
            <th className='text-center'>Đã ép</th>
            <th className='text-center'>QC sau ép</th>
            <th className='text-center'>Chờ may</th>
            <th className='text-center'>Đang may</th>
            <th className='text-center'>Hoàn thành</th>
        </tr>
        </thead>
    )
}

export default DataTableHead
